export const columns: string[] = [
	"date",
	"name",
	"user_id",
	"owner_name",
	"total_hours_logged",
	"average_time_logged",
	"count_logs",
]
